var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartColor20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23333 2.49992C7.93 2.50075 9.3775 5.40908 10 6.69242C10.625 5.40325 12.0575 2.50825 14.7717 2.50825C16.4867 2.50825 18.3333 3.59909 18.3333 5.99325C18.3333 8.86158 14.38 12.5358 10 16.8266C5.61833 12.5341 1.66667 8.86075 1.66667 5.99325C1.66667 3.76325 3.30417 2.49909 5.23333 2.49992ZM5.23417 0.833252C2.58167 0.833252 0 2.65575 0 5.99325C0 9.87742 4.64167 13.8491 10 19.1666C15.3583 13.8491 20 9.87742 20 5.99325C20 2.65075 17.4192 0.841585 14.7717 0.841585C12.935 0.841585 11.0667 1.70992 10 3.53992C8.92917 1.70159 7.065 0.833252 5.23417 0.833252Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.79709,
    y1: 0,
    x2: 7.79709,
    y2: 20.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62CEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8CBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartColor20);
export default __webpack_public_path__ + "static/media/heart-color-20.a2551fe7d2fe1c42dc1ab793c72ce2b2.svg";
export { ForwardRef as ReactComponent };